
<template>
  <div>
    <data-list class="select_checkbox_column_width_0"  :headers="headers" :payload="listPayloadObj" v-model="pagination" :total="total" :pagination="pagination"></data-list>
    <v-dialog v-model="dialog" width="450" persistent>
      <form-template :references.sync="formReferences" :model="modelObj" ref="fieldsReference"></form-template>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import DataList from '@/components/DataList.vue'
import FormTemplate from '@/components/FormTemplate'
export default {
  data () {
    return {
      total: 0,
      dialog: false,
      modelObj: {},
      listPayloadObj: {
        isHeader: true,
        isHideAdd: true,
        selection: [],
        showSelect: true,
        headers: [],
        list: [],
        loading: false,
        showSettingsBack: true,
        editProp: 'mail_address',
        addClickHandler: this.openDialogHandler,
        editHandler: this.getSingleRecordHandler
      },
      loading: false,
      pagination: !this.$formatter.isEmptyObject(this.$store.state.MAILADDRESSFILTER_INDEX) ? this.$store.state.MAILADDRESSFILTER_INDEX : { sortBy: ['mail_address'], itemsPerPage: 25, sortDesc: [false], search: '' },
      MODULE: 'restrictedmails'
    }
  },
  components: {
    DataList,
    FormTemplate
  },
  computed: {
    headers () {
      return [{
        text: this.$t('message.customer.address'),
        value: 'mail_address',
        dbRef: 'Mail_Address',
        isRoute: true,
        isModal: true,
        width: '50%'
      }, {
        text: this.$t('message.tickets.isDomain'),
        isBoolean: true,
        value: 'check_for_domain',
        dbRef: 'Check_For_Domain',
        width: '40%'
      }]
    },
    ...mapState(['FORM_TYPE']),
    formReferences () {
      return {
        title: this.modelObj.id ? this.$t('message.tickets.updateFilter') : this.$t('message.tickets.addFilter'),
        properties: [{
          model: 'mail_address',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.customer.address'),
          class: 'xs12'
        }, {
          model: 'check_for_domain',
          type: this.FORM_TYPE.CHECKBOX,
          rules: [],
          label: this.$t('message.tickets.isDomain'),
          class: 'xs12'
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.modelObj.id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: this.saveUpdateHandler,
          loading: this.loading,
          is_show: true
        }, {
          name: 'close',
          color: 'error',
          click: this.closeDialogHandler,
          label: this.$t('message.common.close'),
          is_show: true
        }]
      }
    }
  },
  watch: {
    pagination: {
      handler (val) {
        let model = { type: 'MAILADDRESSFILTER_INDEX', data: val }
        this.$store.commit('rememberFilter', model)
        this.getListHandler()
      },
      deep: true
    }
  },
  mounted () {
    const text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.MODULE) {
        const payload = { ids: data.ids, url: `${this.MODULE}/delete_multiple`, module: this.MODULE }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE) {
        this.listPayloadObj.selection = []
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getListHandler()
      }
    })
  },
  methods: {
    getListHandler () {
      this.listPayloadObj.loading = true
      this.listPayloadObj.module = this.MODULE
      let queryFields = this.$formatter.cloneVariable(this.headers)
      let { page, search, sortBy, sortDesc, itemsPerPage } = this.$formatter.cloneVariable(this.pagination)
      let pageVal = page || 1
      let query = {
        'order_by': {
          'field': sortBy.join(''),
          'asc_or_desc': sortDesc[0] ? 'desc' : 'asc'
        },
        'skip': ((pageVal - 1) * itemsPerPage),
        'limit': itemsPerPage,
        'include_count': true,
        'filter': `${queryFields.map(x => x.value).join(` contains '${search || ''}' OR `)} contains '${search || ''}'`
      }
      /*  */
      this.$_executeApi('post', `${this.MODULE}/query`, query).then((response) => {
        if (response) {
          let { values, count } = response.data
          this.listPayloadObj.loading = false
          this.listPayloadObj.list = values
          this.total = count
          if (this.pagination.page > 1 && this.total <= this.pagination.itemsPerPage * (this.pagination.page - 1)) {
            this.pagination.page = 1
            this.listPayloadObj.page = 1
          }
        }
      })
    },
    getSingleRecordHandler (id) {
      this.$_executeApi('get', `${this.MODULE}/${id}`)
        .then((result) => {
          if (result.data) {
            this.modelObj = result.data
          }
          this.dialog = true
        })
    },
    openDialogHandler () {
      this.modelObj.isactive = true
      this.dialog = true
    },
    closeDialogHandler () {
      this.dialog = false
      // this.modelObj.id = undefined
      this.modelObj = {}
      this.$refs.fieldsReference.$refs.validateForm.reset()
    },
    saveUpdateHandler () {
      if (this.$refs.fieldsReference.$refs.validateForm.validate()) {
        this.loading = true
        const model = this.modelObj
        let { url, method, text } = ''
        if (!model.id) {
          url = this.MODULE
          method = 'post'
          text = this.$t('message.common.savedSuccess')
        } else {
          url = `${this.MODULE}/${model.id}`
          method = 'put'
          text = this.$t('message.common.updatedSuccess')
        }
        this.$_executeApi(method, url, model)
          .then(() => {
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: text })
            this.closeDialogHandler()
            this.getListHandler()
          })
          .finally(() => {
            this.loading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
  }
}
</script>
